import script from "./Banner.vue?vue&type=script&setup=true&lang=ts"
export * from "./Banner.vue?vue&type=script&setup=true&lang=ts"

import "./Banner.vue?vue&type=style&index=0&id=70572af4&lang=css"

const __exports__ = script;

export default __exports__